import { render, staticRenderFns } from "./ReviewStatements.vue?vue&type=template&id=05a326db&scoped=true&"
import script from "./ReviewStatements.vue?vue&type=script&lang=ts&"
export * from "./ReviewStatements.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewStatements.vue?vue&type=style&index=0&id=05a326db&scoped=true&lang=scss&"
import style1 from "./ReviewStatements.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a326db",
  null
  
)

export default component.exports